import { FC } from 'react';
import { EmptyState } from '../components/EmptyState';

export const HomePageNoCentre: FC = () => <EmptyState message="You don't have a centre assigned to you." />;
